export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8585.f4c9c2f2.jpg";